/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useState, useEffect } from "react";
//images
import IconLeft from "../../../assets/images/IconLeft.png";
import IconRight from "../../../assets/images/IconRight.png";
import IconMiddle from "../../../assets/images/IconMiddle.png";
import ClockIcon from "../../../assets/images/clock.gif";
import direction from "../../../assets/images/confidence.gif";
import Effort from "../../../assets/images/red.gif";
import lackMoney from "../../../assets/images/money.gif";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import BBVDashboardNavbar from "examples/Navbars/BBVDashboardNavbar";
import Slider from "./Slider";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadUserWatchlist } from "reducers/user";

function Default() {
  const [exchange, setExchange] = useState("1T HOF");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userWatchlist = useSelector((state) => state.user.watchlist);
  const defaultWatchlist = [
    {
      s: "NASDAQ:AAPL",
      d: "Apple Inc.",
    },
    {
      s: "NASDAQ:GOOG",
      d: "Alphabet (Google)",
    },
    {
      s: "NASDAQ:AMZN",
      d: "Amazon",
    },
    {
      s: "NASDAQ:FB",
      d: "Meta (Facebook)",
    },
    {
      s: "NASDAQ:MSFT",
      d: "Microsoft",
    },
    {
      s: "NASDAQ:TSLA",
      d: "Tesla",
    },
    {
      s: "NASDAQ:NVDA",
      d: "Nvida",
    },
  ];

  const hof = `<!-- TradingView Widget BEGIN -->
	<div class="tradingview-widget-container">
	  <div class="tradingview-widget-container__widget"></div>
	  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js" async>
	  {
	  "colorTheme": "light",
	  "dateRange": "12M",
	  "showChart": true,
	  "locale": "en",
	  "width": "100%",
	  "height": "400",
	  "largeChartUrl": "",
	  "isTransparent": false,
	  "showSymbolLogo": true,
	  "showFloatingTooltip": false,
	  "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
	  "plotLineColorFalling": "rgba(41, 98, 255, 1)",
	  "gridLineColor": "rgba(240, 243, 250, 0)",
	  "scaleFontColor": "rgba(120, 123, 134, 1)",
	  "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
	  "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
	  "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
	  "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
	  "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
	  "tabs": [
		{
		  "title": "1T Hall of Fame LIST",
		  "symbols": [${
        userWatchlist.length > 0
          ? userWatchlist.map(
              (item) => `{
    "s": "${item.symbol}",
    "d": "${item.name}"
  }`
            )
          : defaultWatchlist.map(
              (item) => `{
          "s": "${item.s}",
          "d": "${item.d}"}`
            )
      }
			
		  ]
		}
	  ]
	}
	  </script>
	</div>
	<!-- TradingView Widget END -->`;

  const configureHTML = () => {
    return hof;
  };

  const tickerTape =
    "https://s.tradingview.com/embed-widget/ticker-tape/?locale=en#%7B%22symbols%22%3A%5B%7B%22proName%22%3A%22FOREXCOM%3ASPXUSD%22%2C%22title%22%3A%22S%26P%20500%22%7D%2C%7B%22proName%22%3A%22FOREXCOM%3ANSXUSD%22%2C%22title%22%3A%22US%20100%22%7D%2C%7B%22proName%22%3A%22FX_IDC%3AEURUSD%22%2C%22title%22%3A%22EUR%2FUSD%22%7D%2C%7B%22proName%22%3A%22BITSTAMP%3ABTCUSD%22%2C%22title%22%3A%22Bitcoin%22%7D%2C%7B%22proName%22%3A%22BITSTAMP%3AETHUSD%22%2C%22title%22%3A%22Ethereum%22%7D%5D%2C%22showSymbolLogo%22%3Atrue%2C%22colorTheme%22%3A%22light%22%2C%22isTransparent%22%3Afalse%2C%22displayMode%22%3A%22adaptive%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A78%2C%22utm_source%22%3A%22www.tradingview.com%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22ticker-tape%22%2C%22page-uri%22%3A%22www.tradingview.com%2Fwidget%2Fticker-tape%2F%22%7D";

  useEffect(() => {
    dispatch(loadUserWatchlist())
  }, [])

  return (
    <DashboardLayout>
      {/* <DashboardNavbar  type="bbv" pageTitle="general statistics" /> */}
      {/* <div className="goldOutline">
        	</div> */}
      <BBVDashboardNavbar type="bbv" pageTitle="BBV Dashboard"></BBVDashboardNavbar>
      <Slider />
      <div style={{ backgroundColor: "white", borderRadius: "15px", marginTop: "20px" }}>
        {/* <FearGreed className="fearGreed"/> */}
        <Grid container style={{ width: "80%", marginLeft: "auto", marginRight: "auto", textAlign: "center" }}>
          <Grid justifyContent="center" alignContent="center" item xl={12} lg={12} md={12} sm={12} xs={12}>
            <h3 className="roboto" style={{ paddingTop: "50px" }}>
              Is this for you?
            </h3>
          </Grid>
          <Grid justifyContent="center" alignContent="center" item xl={12} lg={12} md={12} sm={12} xs={12}>
            <h6 className="roboto darkGrey" style={{ fontSize: "18px", paddingTop: "30px", paddingBottom: "40px" }}>
              Bull Bear Vector is build for investors by investors. The platform is created for beginners to seasoned
              investors, using methodologies backed by investment gurus like Warren Buffett, Ray Dalio, Joel Greenblatt,
              etc. Head over to the features page to know what suit you most.
            </h6>
          </Grid>
          <Grid style={{ paddingBottom: "46px" }} justifyContent="center" alignContent="center" spacing={4} container>
            <Grid justifyContent="center" alignContent="center" item xl={4} lg={4} md={4} sm={12} xs={12}>
              <img src={IconLeft} alt="clock"></img>
              <h4 className="roboto titleGrey" style={{ fontSize: "24px", height: "80px" }}>
                Don’t have time to research?
              </h4>
              <p className="roboto_medium darkGrey" style={{ fontSize: "16px", paddingTop: "6px" }}>
                We know that you might be busy with work, family, and a healthy lifestyle, BBV can help you cut short
                your time to find strong companies.
              </p>
            </Grid>
            <Grid justifyContent="center" alignContent="center" item xl={4} lg={4} md={4} sm={12} xs={12}>
              <img src={IconMiddle} alt="clock"></img>
              <h4 className="roboto titleGrey" style={{ fontSize: "24px", height: "80px" }}>
                Not sure what to do?
              </h4>
              <p className="roboto_medium darkGrey" style={{ fontSize: "16px", paddingTop: "6px" }}>
                Financial literacy is important! You don't want to speculate and invest whatever is out there, BBV can
                help you find strong stocks, scan fat options and even give you direction!
              </p>
            </Grid>
            <Grid justifyContent="center" alignContent="center" item xl={4} lg={4} md={4} sm={12} xs={12}>
              <img src={IconRight} alt="clock"></img>
              <h4 className="roboto titleGrey" style={{ fontSize: "24px", height: "80px" }}>
                How to profit with ease?
              </h4>
              <p className="roboto_medium darkGrey" style={{ fontSize: "16px", paddingTop: "6px" }}>
                Some of us might want to see profit immediately, but patience and due diligence is key to be profitable.
                BBV can help you identify opportunities, and market sentiments, showing you risks and rewards.
              </p>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <Grid justifyContent="space-between" style={{ textAlign: "center" }} container>
        <Grid className="dashboardCards" item>
          <img className="dashboardCardsImg" src={ClockIcon} alt="clock"></img>
          <h4 className="roboto" style={{ fontSize: "24px" }}>
            Save Time
          </h4>
          <p className="roboto_medium darkGrey" style={{ fontSize: "16px", paddingTop: "10px" }}>
            You save time researching for strong companies in just less than 15 mins!
          </p>
        </Grid>
        <Grid className="dashboardCards" item>
          <img className="dashboardCardsImg" src={Effort} alt="clock"></img>
          <h4 className="roboto" style={{ fontSize: "24px" }}>
            Reduce Effort
          </h4>
          <p className="roboto_medium darkGrey" style={{ fontSize: "16px", paddingTop: "10px" }}>
            You dont need to be a geek of financially savvy to start researching and make informed decisions to invest
          </p>
        </Grid>
        <Grid className="dashboardCards" item>
          <img className="dashboardCardsImg" src={direction} alt="clock"></img>
          <h4 className="roboto" style={{ fontSize: "24px" }}>
            Give Direction
          </h4>
          <p className="roboto_medium darkGrey" style={{ fontSize: "16px", paddingTop: "10px" }}>
            You gain clarity and understood how to invest the right method
          </p>
        </Grid>
        <Grid className="dashboardCards" item>
          <img className="dashboardCardsImg" src={lackMoney} alt="clock"></img>
          <h4 className="roboto" style={{ fontSize: "24px" }}>
            Stay Safe
          </h4>
          <p className="roboto_medium darkGrey" style={{ fontSize: "16px", paddingTop: "10px" }}>
            You with clarity, invest safely with the help of BBV
          </p>
        </Grid>
      </Grid>
      <div style={{ backgroundColor: "white", paddingTop: "15px", marginTop: "20px", borderRadius: "15px" }}>
        <iframe
          className="tickerTape"
          title="technical3"
          style={{ width: "100%", border: "none" }}
          src={tickerTape}
        ></iframe>
        {/* <p className="centerText" style={{ paddingBottom: "8px" }}>
					CII STREAMLINE (customized)
				</p> */}
      </div>
      <div
        style={{
          textAlign: "center",
          backgroundColor: "white",
          borderRadius: "15px",
          marginTop: "20px",
          paddingTop: "20px",
        }}
      >
        <h3 className="roboto" style={{ marginBottom: "30px" }}>
          Watchlist
        </h3>
        <iframe
          style={{ width: "100%", height: "440px" }}
          className="iframeDashboard"
          title="indices"
          srcDoc={configureHTML()}
        ></iframe>
        <Button
          style={{ marginBottom: "30px" }}
          variant="contained"
          className="bbvGold"
          onClick={() => navigate("/dashboard/pages/account/settings")}
        >
          Manage your Watchlist &nbsp;&nbsp;&nbsp; <ArrowForwardIcon />
        </Button>
      </div>
      <Grid
        justifyContent="center"
        style={{
          textAlign: "center",
          backgroundColor: "white",
          borderRadius: "15px",
          marginTop: "20px",
          paddingTop: "20px",
        }}
        container
      >
        <h3 className="roboto" style={{ marginBottom: "30px" }}>
          What our users are saying
        </h3>
        {/* <iframe title="testimonial" id="testimonialto-bull-bear-vector-light-animated" src="https://embed-v2.testimonial.to/w/bull-bear-vector?animated=on&theme=light&shadowColor=ffffff" frameBorder="0" scrolling="no" width="100%" height="800px"></iframe> */}
        <iframe
          title="testimonial"
          id="testimonialto-grid-selected-bull-bear-vector-light-animated"
          src="https://embed.testimonial.to/w/bull-bear-vector?animated=on&theme=light&shadowColor=ffffff"
          frameBorder="0"
          scrolling="no"
          width="100%"
          height="650px"
        ></iframe>
      </Grid>

      {/* <Grid
        className="bbvRed"
        container
        style={{
          marginTop: "20px",
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
          padding: "35px",
          borderRadius: "15px",
        }}
      >
        <Grid justifyContent="center" alignContent="center" item xl={12} lg={12} md={12} sm={12} xs={12}>
          <h2
            className="footerText roboto"
            style={{
              color: "white",
              marginLeft: "auto",
              marginRight: "auto",
              fontSize: "36px",
              marginBottom: "26px",
            }}
          >
            Do you need help how to find a stock & option in 5 min
          </h2>
        </Grid>
        <Grid justifyContent="center" alignContent="center" item xl={12} lg={12} md={12} sm={12} xs={12}>
          <p
            className="footerText roboto"
            style={{
              color: "white",
              paddingBottom: "40px",
              fontSize: "18px",
              marginLeft: "auto",
              marginRight: "auto",
              marginBottom: "15px",
            }}
          >
            Complementary workshop: Discover 4 proven strategies to explode your wealth even if the market crashes this
            month
          </p>
        </Grid>
        <Grid justifyContent="center" alignContent="center" item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Button className="bbvGold" variant="contained">
            Book your seat
          </Button>
        </Grid>
      </Grid> */}

      <Footer />
    </DashboardLayout>
  );
}

export default Default;
